import React from 'react';
import { Backdrop, CircularProgress, LinearProgress, Box, Typography, useTheme } from '@mui/material';
import { useLoading } from '@contexts/LoadingContext';

/**
 * Componente de loading global que exibe um overlay com spinner e, opcionalmente, barra e % de progresso.
 * Deve ser usado uma única vez no App.tsx
 */
const GlobalLoading: React.FC = () => {
  const { isLoading, loadingMessage, loadingProgress } = useLoading();
  const theme = useTheme();
  const showProgress = loadingProgress !== null;

  if (!isLoading) {
    return null;
  }

  return (
    <Backdrop
      open={isLoading}
      sx={{
        color: '#fff',
        zIndex: theme.zIndex.modal + 1,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        backdropFilter: 'blur(2px)',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
          minWidth: 280,
          maxWidth: 360,
        }}
      >
        {!showProgress && (
          <CircularProgress
            size={60}
            thickness={4}
            sx={{
              color: 'primary.main',
              '& .MuiCircularProgress-circle': {
                strokeLinecap: 'round',
              },
            }}
          />
        )}
        {loadingMessage && (
          <Typography
            variant="body1"
            sx={{
              color: 'white',
              fontWeight: 500,
              textAlign: 'center',
              maxWidth: 300,
              px: 2,
            }}
          >
            {loadingMessage}
          </Typography>
        )}
        {showProgress && (
          <Box sx={{ width: '100%', px: 2 }}>
            <LinearProgress
              variant="determinate"
              value={loadingProgress ?? 0}
              sx={{
                height: 8,
                borderRadius: 4,
                bgcolor: 'rgba(255,255,255,0.2)',
                '& .MuiLinearProgress-bar': {
                  borderRadius: 4,
                },
              }}
            />
            <Typography
              variant="caption"
              sx={{
                color: 'rgba(255,255,255,0.9)',
                display: 'block',
                textAlign: 'center',
                mt: 0.75,
              }}
            >
              {Math.round(loadingProgress ?? 0)}%
            </Typography>
          </Box>
        )}
      </Box>
    </Backdrop>
  );
};

export default GlobalLoading;

